import * as locales from 'date-fns/locale';

export function getLocaleObject(locale) {
  return locales[locale];
}
